import { ref } from 'vue';
import { defineStore } from 'pinia';

import { http } from '@/plugins/axios';
import bus from '@/plugins/bus';
import { useAuthStore } from '@/modules/auth/store/auth.store.ts';

export const useUser = defineStore(
  'user',
  () => {
    const ephemeral = ref({ beta: false });

    const auth = useAuthStore();

    const data = ref<{
      name: string;
      surname: string;
    } | null>(null);
    const loaded = ref(false);
    const loading = ref(false);

    const callbacks = {
      resolve: (value: any) => {},
      reject: (error: any) => {},
    };
    const loader = ref<Promise<void>>();
    const resetLoader = () => {
      loader.value = new Promise((resolve, reject) => {
        callbacks.resolve = resolve;
        callbacks.reject = reject;
      });
      return loader.value;
    };
    resetLoader();

    const actions = {
      enterBetaMode: () => {
        ephemeral.value.beta = true;
        bus.emit('user.beta', true);
      },
      leaveBetaMode: () => {
        ephemeral.value.beta = false;
        bus.emit('user.beta', false);
      },
      initialize: async () => {
        if (loaded.value || loading.value) {
          return loader.value;
        }

        loaded.value = false;
        loading.value = true;
        try {
          const user = await http.get('/user');

          data.value = user.data.content;

          loaded.value = true;
          loading.value = false;

          callbacks.resolve(true);

          bus.emit('user.beta', ephemeral.value.beta);
          return true;
        } catch (error) {
          callbacks.reject(error);
          resetLoader();
          loaded.value = false;
          loading.value = false;
        }

        return false;
      },
      clear: () => {
        data.value = null;
        ephemeral.value = {
          beta: false,
        };
        loaded.value = false;
        loading.value = false;
        return true;
      },
      getEphemeral: () => {},
    };

    const isAuthenticated = async (): Promise<boolean> => {
      const tokenOk = await auth.isAuthenticated();
      if (tokenOk) {
        await actions.initialize();
      }
      return tokenOk;
    };

    return {
      ...actions,
      data,
      ephemeral,
      loaded,
      loading,
      isAuthenticated,
    };
  },
  {
    persist: {
      key: 'user-20250610',
      pick: ['ephemeral', 'data'],
    },
  },
);
